'use client'
import { checkHaveCountry } from '@/src/lib/utils'
import { useToken } from '@/src/store/token-store'
import { useUser } from '@/src/store/user-store'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

const notAllowedRoutesLoggedIn = [
  '/auth/login',
  '/auth/signup',
  '/auth/login/',
  '/auth/signup/',
  // '/auth/password',
  // '/auth/password/new',
]

const notAllowedRoutesLoggedOut = [
  '/auth/password/new',
  // '/auth/verify',
  // '/auth/verify/onboarding',
]

export const AuthenticationCheck = () => {
  const { user, _hasHydrated, setRefreshToken } = useUser()
  const pathname = usePathname()
  const router = useRouter()
  const searchParams = useSearchParams()
  const { setToken } = useToken()

  useEffect(() => {
    const device = searchParams.get('device')
    const token = searchParams.get('token')
    const rtoken = searchParams.get('rtoken')
    const action = searchParams.get('action')
    if (user == null && device === 'app' && token && rtoken) {
      setToken(token)
      setRefreshToken(rtoken)
    }
    let reqFieldsReopen = user && (user?.isBusinessUser !== '1' ? (!user.dob || !user.gender || !checkHaveCountry(user.countryId)) : !checkHaveCountry(user.countryId))
    if (user !== null && user.verifiedUser == '0' && _hasHydrated) {
      if (pathname === '/auth/tvsignup' || pathname === '/auth/tvlogin' || device === 'tv') { router.replace('/auth/verify?device=tv') } else { router.replace('/auth/verify') }
    } else if (user !== null && user.isOnboarded == '0' && _hasHydrated) {
      if (pathname === '/auth/tvsignup' || pathname === '/auth/tvlogin' || device === 'tv') { router.replace('/auth/verify/onboarding?device=tv') } else { router.replace('/auth/verify/onboarding') }
    } else if (user !== null &&
      reqFieldsReopen &&
      _hasHydrated) {
      if (pathname === '/auth/tvsignup' || pathname === '/auth/tvlogin' || device === 'tv') { router.replace('/auth/verify/onboarding?device=tv'+ (action ? `?action=${action}` : '')) } else { router.replace('/auth/verify/onboarding'+ (action ? `?action=${action}` : '')) }
      // router.replace('/auth/verify/onboarding/aa' + (action ? `?action=${action}` : ''))
    } else if (
      user !== null &&
      notAllowedRoutesLoggedIn.includes(pathname || '') &&
      _hasHydrated
    ) {
      if (pathname === '/auth/tvsignup' || pathname === '/auth/tvlogin' || device === 'tv') {
        const redirectUrl = localStorage.getItem('redirectUrl') || '/home?device=tv'
        router.replace(redirectUrl)
      } else if ((user.interestIds.length === 0 || user.languageIds.length === 0)) {
        console.log("user", user);
        router.replace('/auth/verify/onboarding' + (action ? `?action=${action}` : ''))
      } else {
        const redirectUrl = action === 'activate_wallet' ? '/earnings' : (localStorage.getItem('redirectUrl') || '/home')
        console.log("userIN1", user);
        router.replace(redirectUrl)
      }

    } else if (
      user === null &&
      notAllowedRoutesLoggedOut.includes(pathname || '') &&
      _hasHydrated
    ) {
      router.replace('/auth/login')
    }
  }, [user, router, _hasHydrated, pathname])

  return <></>
}
